import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();

  useEffect(() => {
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        await api.post("/auth/google/session", null, { headers: { "X-Session-ID": session_id } });
        await refresh();
        toast.success("Signed in with Google");
        window.location.replace("/account");
      } catch {
        toast.error("Google sign-in failed");
        nav("/login");
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-[60vh] grid place-items-center">
      <div className="text-slate-600">Signing you in…</div>
    </div>
  );
}
